<template>
  <div>
    <vue-tags-input
      prepend="@"
      class="vue-tags-input"
      v-model="itemText"
      :tags="selectedItems"
      :autocomplete-items="internalAutocompleteItems"
      :placeholder="$props.placeholder"
      :add-only-from-autocomplete="true"
      :max-tags="$props.maxTags || 9999"
      :autocomplete-always-open="$props.autocompleteAlwaysOpen"
      autocomplete
      @tags-changed="update"
      :disabled="$props.disabled"
      @change="initItems"
      @before-adding-tag="handleBeforeAdding"
    >
      <div
        slot="autocomplete-item"
        slot-scope="props"
        class="my-item"
        @click="props.performAdd(props.item)"
      >
        {{ props.item[$props.main_name_key] }}
        <br />
        <small>{{ smallText(props) }}</small>
      </div>
    </vue-tags-input>
  </div>
</template>
<script>
import VueTagsInput from "@johmun/vue-tags-input";
import { HapiService } from "@/core/services/hapi.service";

export default {
  name: "MultiTags",
  props: {
    main_name_key: String,
    secondary_name_key: String,
    autocompleteEndpoint: String,
    autocompleteItems: Array,
    autocompleteAlwaysOpen: String,
    placeholder: String,
    maxTags: Number,
    disabled: Boolean,
    searchParam: {
      type: String,
      default: "text"
    },
    searchMethod: {
      type: String,
      default: "query"
    },
    credentials: {
      type: Object,
      default: null
    }
  },
  components: { VueTagsInput },
  computed: {},
  data() {
    return {
      itemText: "",
      selectedItems: [],
      internalAutocompleteItems: [],
      search: ""
    };
  },
  methods: {
    smallText(props) {
      const text = props.item[this.$props["secondary_name_key"]];
      if (typeof text === "object" && text !== null) {
        if ("name" in text) {
          return text["name"];
        }
      }
      return text;
    },
    update(newTags) {
      console.log("updating ", newTags);
      this.selectedItems = newTags;
      const tagsToEmitOnInputEvent = [...newTags];
      tagsToEmitOnInputEvent.forEach(
        (val, index) => (tagsToEmitOnInputEvent[index] = val.id.toString())
      );
      this.$emit("input", tagsToEmitOnInputEvent);
      this.$emit("tags-changed", newTags);
    },
    initItems() {
      if (!this.itemText) {
        return;
      }
      if (!this.$props.autocompleteEndpoint) {
        this.$log.warn("filtering");
        return this.filterItems();
      }
      let params = {};
      if (this.$props.searchParam)
        params[this.$props.searchParam] = this.itemText;
      if (this.$props.credentials) {
        params["credentials"] = this.$props.credentials;
      }
      HapiService.apiService[this.$props.searchMethod](
        this.$props.autocompleteEndpoint,
        params
      )
        .then(response => {
          // eslint-disable-next-line no-prototype-builtins
          if (response.data.hasOwnProperty("results")) {
            response.data = response.data.results;
          }
          response.data.forEach(
            (v, k) => (v["text"] = v[this.$props.main_name_key])
          );
          this.internalAutocompleteItems = response.data;
        })
        .catch(e => console.warn("Oh. Something went wrong", e));
    },
    filterItems() {
      let self = this;
      this.internalAutocompleteItems = [...self.$props.autocompleteItems];
      this.internalAutocompleteItems.forEach((v, k) => {
        v["text"] = v[this.$props.main_name_key];
        // eslint-disable-next-line no-prototype-builtins
        if (v.hasOwnProperty("count")) {
          v["text"] = `${v["text"]} (${v["count"]})`;
        }
      });
      this.internalAutocompleteItems = [
        ...this.internalAutocompleteItems.filter(i => {
          return (
            i.text.toLowerCase().indexOf(self.itemText.toLowerCase()) !== -1
          );
        })
      ];
    },
    onOptionClick({ option, addTag }) {
      addTag(option);
      this.itemText = "";
    },
    handleBeforeAdding(event) {
      if (this.itemText) event.addTag(event.tag);
    }
  },
  watch: {
    itemText: "initItems"
  }
};
</script>

<style scoped>
.vue-tags-input {
  /*min-width: 300px !important;*/
}

.ti-tag {
}
</style>
